export default {
  data() {
    return {
      onboardingStepsConst: [
        {label: this.$t('onboarding.v3.step_1_0'), value: 'STEP_1_0'},
        {label: this.$t('onboarding.v3.step_1_1'), value: 'STEP_1_1'},
        {label: this.$t('onboarding.v3.step_1_2'), value: 'STEP_1_2'},
        {label: this.$t('onboarding.v3.step_1_3'), value: 'STEP_1_3'},
        {label: this.$t('onboarding.v3.step_1_4'), value: 'STEP_1_4'},
        {label: this.$t('onboarding.v3.step_1_5'), value: 'STEP_1_5'},
      ],
    };
  },
  methods: {
    displayForOnboardingStepsConst(value) {
      let result = this.onboardingStepsConst.find((el) => el.value === value);
      return result ? result.label : '';
    },
  },
  computed: {
    onboardingStepsConstAlphabetical() {
      return this.onboardingStepsConst.sort((a, b) => {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      });
    },
  },
};
